module.exports = __webpack_public_path__ + "img/order-ys.8ee6bd33.png";